import React, { forwardRef } from 'react';
import CapturedPiecesLegend from './CapturedPiecesLegend';
import { Piece } from '../model/Piece';

interface ComputerCapturedPiecesProps {
  pieces: Piece[];
  isPortrait?: boolean;
  isMobile?: boolean;
}

const ComputerCapturedPieces = forwardRef<HTMLDivElement, ComputerCapturedPiecesProps>(
  ({ pieces, isPortrait = true, isMobile = false }, ref) => {
  return (
    <CapturedPiecesLegend
      ref={ref}
      title="Computer"
      pieces={pieces}
      pieceColor="black"
      backgroundColor="grey"
      isPortrait={isPortrait}
      isMobile={isMobile}
    />
  );
});

export default ComputerCapturedPieces;
